import React from "react";
import LegalMaterial from "../../components/LegalMaterial";
import "./style.scss";
import usePolicyText from "../../hooks/usePolicyText";

export default function PrivacyPolicy() {
  // t — из хука с пином EN: иначе на RU-локали new_policy_* рендерились
  // сырыми ключами (страница EN-only by design)
  const { t, renderTitle, renderTwoLevelParagraph } = usePolicyText("en");

  return (
    <LegalMaterial header={t("new_policy_title")}>
      <div className="privacy-policy-page">
        <div className="privacy-policy-page__general-desc">
          {t("new_privacy_general")}
        </div>
        {renderTwoLevelParagraph("new_policy_1")}
        {renderTwoLevelParagraph("new_policy_2")}

        {renderTitle("new_policy_3")}
        {renderTwoLevelParagraph("new_policy_3", "new_policy_3_1", true)}
        {/* Этап 2: реферальная программа и баллы (EN-адаптация раздела 5.3) */}
        {renderTwoLevelParagraph("new_policy_3", "new_policy_3_2", true)}

        {renderTitle("new_policy_4")}
        {renderTwoLevelParagraph("new_policy_4", "new_policy_4_1", true)}

        {renderTwoLevelParagraph("new_policy_5")}
        {renderTwoLevelParagraph("new_policy_6")}
        {renderTwoLevelParagraph("new_policy_7")}
        {renderTwoLevelParagraph("new_policy_8")}
      </div>
    </LegalMaterial>
  );
}
